// src/redux/slices/menusSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { safeParse } from "../../helper/helper"; 

const initialState = {};

const menusSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {
    setMenus: (state, action) => {
      state.menus = action.payload;
      safeParse(sessionStorage.setItem("menus", JSON.stringify(action.payload)));
    },
    clearMenus: (state) => {
      state.menus = null;
      safeParse(sessionStorage.removeItem("menus"));
    },
  },
});

export const { setMenus, clearMenus } = menusSlice.actions;
export default menusSlice.reducer;
